<template>
  <div class="columns" style="background-color: #E2E2E2;">

  <loading :active.sync="visible" :color="'#7957d5'" :can-cancel="true"></loading>

    <div class="column is-three-fifths">
      <h1 class="title is-1 ">Crear Requisicion</h1>
        <div class="box">

          <div class="columns">
            <div class="column">
              <p class="has-text-grey">Puesto a solicitar </p>
              <div class="select">
                <select v-model="electo" @change="setPuesto(electo)" >
                  <option selected>Seleccione Puesto </option>
                  <option v-for="puesto in puestos" :value="puesto">{{puesto.puesto}} </option>
                </select>
              </div>
            </div>
            <div class="column">
              <p class="has-text-grey"> Vacantes Requeridos </p>
              <div class="select">
                <select v-model="uCantidadReq" >
                  <option  selected>Seleccione cantidad </option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                </select>
              </div>
            </div>
          </div>

          <br><br>
          <p class="has-text-grey">Escribir requisitos para {{puestoName}}  </p>
          <textarea class="textarea" placeholder="ej. 1 año de experiencia" v-model="requisitos" rows="10"> {{requisitos}} </textarea>
          <br>
          <p v-if="errors2.length > 0 " style="color:red;" >
           <ul>
             <li v-for="error in errors2"> ☒ {{ error }}</li>
           </ul>
         </p>
         <br>
          <a class="button is-link" @click="crearRequisicion()"> Solicitar  </a>
        </div>
        <br>
    </div>

    <div class="column is-one-fifth"></div>

  </div>
</template>

<script>

import axios from 'axios'
import Cors from 'cors'
import moment from 'moment'
import searchMix from '@/components/mixins/mixin'
import { SnotifyPosition, SnotifyStyle } from 'vue-snotify'
import { EventBus } from '@/components/bus.js';
import Loading from 'vue-loading-overlay';

export default {
  components:{
    Loading
  },
  data () {
    return {
      menuComponente: 'app-create',
      puestos: [],
      requisitos: '',
      idPuesto: '',
      puestoName: '',
      uCantidadReq: 1,
      errors2: [],
      descripcionpuesto: '',
      electo: '',
      visible:false
    }
  },
  created () {
  this.visible = true
    this.getPuesto(this.$cookies.get('RhSession').id_depar) // obtener solo los puesto de ese gerente
  },
  methods: {
    setPuesto (val) {
      console.log(val)
      this.idPuesto = val.id
      this.puestoName = val.puesto
      this.requisitos = val.requisitos
    },
    getPuesto: function (p) {
      var estancia = this

      if(this.$cookies.get('RhSession').name == 'admin' ){
        console.log('el usuario es administrador ');

        axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
          select: '*',
          table: 'puestos',
          where: 'departamentos_id > 0 ',
          condition: ''
        })
          .then(function (response) {
            if (response.status == 200) {
              estancia.visible = false
              estancia.puestos = response.data
            } else {
              console.log('error')
            }
          })

      }else{
        console.log('el usuario no es administrador ');

        axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
          select: '*',
          table: 'puestos',
          where: 'departamentos_id = ' + p,
          condition: ''
        })
          .then(function (response) {
            if (response.status == 200) {
              estancia.puestos = response.data
            } else {
              console.log('error')
            }
          })
      }

    },
    crearRequisicion: function () {
      var estancia = this
      this.visible = true

      this.insertRegistro($cookies.get('RhSession').name, 'requisiciones' , 0, ' se crea la requisicion ', ' - ');

      this.errors2 = []

      if (this.requisitos != '' && this.$cookies.get('RhSession').name != '') {
        axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/write', {
          table: 'requisicion',
          columns: 'gerente, puesto_requerido, requisitos, fecha, status_requisicion_id, puestos_id, created_at, updated_at, vacantes',
          values: ` '${estancia.$cookies.get('RhSession').name}', '${estancia.puestoName}','${estancia.requisitos}','${moment().format('YYYY-MM-DD')}',0, '${estancia.idPuesto}', '${moment().format('YYYY-MM-DD HH:mm:ss')}','${moment().format('YYYY-MM-DD HH:mm:ss')}', '${estancia.uCantidadReq}' `
        })
          .then(function (response) {
            if (response.status == 200) {
              estancia.requisitos = ''
              estancia.visible = false

              estancia.$snotify.success('Se creo requisicion ', 'Requisicion', {
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true
              })

              EventBus.$emit('cambioCompon', 4, 'app-request');

            } else {
              console.log('error')
            }
          })
      } else {
        if (this.requisitos == '') { this.errors2[0] = 'Ingrese Los Requisitos' }
        if (this.selectDatos == '') { this.errors2[1] = 'Seleccione el puesto' }
      }
    }

  },
  mixins: [searchMix]

}
</script>
